<template>
	<div class="two-column">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'TwoColumn'
}
</script>

<style lang="scss" scoped>
@import '~scss/mq';

.two-column {
	display: grid;
	grid-template-rows: auto;
	grid-template-columns: 1fr;
	column-gap: 3rem;
	row-gap: 0.5rem;

	&.fieldset {
		row-gap: 2rem;
	}

	@include mq(md) {
		grid-template-rows: auto;
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>
